module.exports = __webpack_public_path__ + "img/google-maps-profile.f88fddfe.svg";